import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-c01-form-note-panel-drink" }
const _hoisted_2 = { class: "p-the-c01-form-note-panel-drink__top" }
const _hoisted_3 = { class: "p-the-c01-form-note-panel-drink__bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconDrinkStop = _resolveComponent("IconDrinkStop")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_InputCheckBox = _resolveComponent("InputCheckBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconBase, {
        width: 48,
        height: 68,
        "view-box": "0 0 48 68"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconDrinkStop)
        ]),
        _: 1
      }),
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "p-the-c01-form-note-panel-drink__top__text" }, [
        _createTextVNode(" ※未成年者の飲酒は法律で禁止されています。 "),
        _createElementVNode("br"),
        _createTextVNode("※飲酒は20歳になってから。飲酒運転は法律で禁止されています。 "),
        _createElementVNode("br"),
        _createTextVNode("※妊娠中や授乳期の飲酒は、胎児・乳児の発育に悪影響を与える恐れがあります。 ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_InputCheckBox, {
        id: "is_adult",
        name: "is_adult",
        value: _ctx.value,
        onChecked: _ctx.onCheckAdult
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("私は20歳以上です", -1)
        ])),
        _: 1,
        __: [1]
      }, 8, ["value", "onChecked"])
    ])
  ]))
}